import moment from 'moment';

// Ensure moment is available globally
if (typeof window !== 'undefined') {
  window.moment = moment;
}

export default moment; 